export default __webpack_public_path__ + "static/iceberg-dd7038d1035d90927bc4a126f76ff112.png";